// extracted by mini-css-extract-plugin
module.exports = {"ListItem":"PaginatedList_ListItem__3_472","Button":"PaginatedList_Button__39ro1"};